exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".forward-form[data-v-7dfd4881]{padding:0 20px}", ""]);

// exports
